import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { EveReportingControlWidgetWidget } from '../../../../../services/ControlWidgetService.service';




@Component({
  selector: 'number-input-control-widget-menu-settings',
  templateUrl: 'number-input-control-widget-menu-settings.component.html',
  styleUrls: ['./number-input-control-widget-menu-settings.component.css'],
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm }
  ]
})
export class NumberInputControlWidgetMenuSettingsComponent implements OnInit {

  @Input()
  widget?: EveReportingControlWidgetWidget = null;

  constructor(

  ) {


  }
    ngOnInit(): void {
      
    }


}



